/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo } from 'react'

import { const_var, params } from '../../../../../redux/reducers/reducer';

import { convertFeet } from '../../../../../utils/ConvertFeet';
// import { convertSizeFormat, getMaxHeight, sortDoorObject } from '../../../../../utils/Functions';

import LineModel from '../../LineModel'
import DimensionValue from '../../DimensionValue';
import DoorSideLine from '../../DoorSideLine';
import { wallNameArrForValid } from '../../../../../utils/Validation';

const Door_Measurements = ({compType, isDrag, bindDelta, positionX, positionY, positionZ, height, width, wallName, id, color="#2F7CBF"}) => {
    const [arrowLength, setArrowLength] = useState(0);
    const [arrowPosition, setArrowPosition ] = useState(0);
    const [ topHeight, setTopHeight ] = useState(0)
    const [widthLeft, setWidthLeft] = useState(params.p_w / 2 - width / 2);
    const [widthRight, setWidthRight] = useState(params.p_w / 2 - width / 2);
    const [targetDoorSize, setTargetDoorSize] = useState('');
    const [heightestSize, setHeightestSize] = useState(0);
    const [ verticalArrowLength, setVerticalArrowLength ] = useState(0);
    const [leftAngle, setLeftAngle] = useState(0);
    const [rightAngle, setRightAngle] = useState(0);

    const sideDoorArray = const_var.newDoorsArray.filter((item) => item.userData.wallName === wallName);

    const limitX = useMemo(() => {        
        if(wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w' || wallName === 'c_b_b_s_w') {
            return {
                min: -(params.p_w / 2),
                max: params.p_w / 2
            }
        } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_l_w') {
            return {
                min: -(params.p_d / 2),
                max: params.p_d / 2
            }
        } else if (wallName === 'F_L_R_W' || wallName === 'F_L_R_S_W') {
            return {
                min: -params.p_d / 2 - 0.15 - params.leanF_p_w,
                max: -params.p_d / 2 - 0.15
            }
        } else if (wallName === 'F_L_L_W' || wallName === 'F_L_L_S_W') {
            return {
                min: params.p_d / 25,
                max: params.p_d / 2 + 0.15 + params.leanF_p_w
            }
        } else if (wallName === 'F_L_F_W') {
            return {
                min: params.add_left_front_lean_porch ? params.leanF_p_pos - params.leanF_p_d / 2 - params.lean_p_w : params.leanF_p_pos - params.leanF_p_d / 2,
                max: params.add_right_front_lean_porch ? params.leanF_p_pos + params.leanF_p_d / 2 + params.leanR_p_w : params.leanF_p_pos + params.leanF_p_d / 2
            }
        } else if (wallName === 'B_L_F_W' || wallName === 'B_L_L_S_W') {
            return {
                min: params.p_d / 2 + 0.15,
                max: params.p_d / 2 + 0.15 + params.leanB_p_w
            }
        } else if (wallName === 'B_L_B_W' || wallName === 'B_L_R_S_W') {
            return {
                min: -params.p_d / 2 - 0.15 - params.leanB_p_w,
                max: -params.p_d / 2 - 0.15
            }
        } else if (wallName === 'B_L_S_W') {
            return {
                min: params.add_right_back_lean_porch ? -params.leanB_p_pos - params.leanB_p_d / 2 - params.leanR_p_w : -params.leanB_p_pos - params.leanB_p_d / 2,
                max: params.add_left_back_lean_porch ? -params.leanB_p_pos + params.leanB_p_d / 2 + params.lean_p_w : -params.leanB_p_pos + params.leanB_p_d / 2
            }
        } else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
            return {
                min: params.p_w / 2,
                max: params.p_w / 2 + params.leanR_p_w
            }
        } else if (wallName === 'R_L_B_W' || wallName === 'R_L_B_S_W') {
            return {
                min: -params.p_w / 2 - params.leanR_p_w,
                max: -params.p_w / 2
            }
        } else if (wallName === 'R_L_R_W') {
            return {
                min: params.add_right_front_lean_porch ? -params.leanR_p_pos - params.leanR_p_d / 2 - params.leanF_p_w : -params.leanR_p_pos - params.leanR_p_d / 2,
                max: params.add_right_back_lean_porch ? -params.leanR_p_pos + params.leanR_p_d / 2 + params.leanB_p_w : -params.leanR_p_pos + params.leanR_p_d / 2
            }
        } else if (wallName === 'L_L_F_W' || wallName === 'L_L_F_S_W') {
            return {
                min: -params.p_w / 2 - params.lean_p_w,
                max: -params.p_w / 2
            }
        } else if (wallName === 'L_L_B_W' || wallName === 'L_L_B_S_W') {
            return {
                min: params.p_w / 2,
                max: params.p_w / 2 + params.lean_p_w
            }
        } else if (wallName === 'L_L_L_W') {
            return {
                min: params.add_left_back_lean_porch ? params.lean_p_pos - params.lean_p_d / 2 - params.leanB_p_w : params.lean_p_pos - params.lean_p_d / 2,
                max: params.add_left_front_lean_porch ? params.lean_p_pos + params.lean_p_d / 2 + params.leanF_p_w : params.lean_p_pos + params.lean_p_d / 2
            }
        } else if (wallName === 'c_b_r_s_w') {
            return {
                min: -(parseInt(params.p_u_t) - params.p_d / 2) - params.endStoragePositionZ,
                max: params.p_d / 2 - params.endStoragePositionZ
            }
        } else if (wallName === 'c_b_l_s_w') {
            return {
                min: -(params.p_d / 2) + params.endStoragePositionZ,
                max: parseInt(params.p_u_t) - params.p_d / 2 + params.endStoragePositionZ
            }
        } else if (wallName === 'c_b_l_s_f_w') {
            return {
                min: -(params.p_w / 2),
                max: -params.p_w / 2 + parseInt(params.cB_addStorage_left)
            }
        } else if (wallName === 'c_b_l_s_b_w') {
            return {
                min: params.p_w / 2 - parseInt(params.cB_addStorage_left),
                max: params.p_w / 2
            }
        } else if (wallName === 'c_b_r_s_f_w') {
            return {
                min: params.p_w / 2 - parseInt(params.cB_addStorage_right),
                max: params.p_w / 2
            }
        } else if (wallName === 'c_b_r_s_b_w') {
            return {
                min: -(params.p_w / 2),
                max: -params.p_w / 2 + parseInt(params.cB_addStorage_right)
            }
        } else if (wallName === 'F_L_F_S_W') {
            return {
                min: params.leanF_p_pos - params.leanF_p_d / 2 + params.frontLeanStoragePosition,
                max: params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front) + params.frontLeanStoragePosition
            }
        } else if (wallName === 'B_L_F_S_W') {
            return {
                min: -params.leanB_p_pos + params.leanB_p_d / 2 - parseInt(params.add_storage_back) - params.backLeanStoragePosition,
                max: -params.leanB_p_pos + params.leanB_p_d / 2 - params.backLeanStoragePosition
            }
        } else if (wallName === 'R_L_R_S_W') {
            return {
                min: -params.leanR_p_pos + params.leanR_p_d / 2 - parseInt(params.add_storage_right) - params.rightLeanStoragePosition,
                max: -params.leanR_p_pos + params.leanR_p_d / 2 - params.rightLeanStoragePosition
            }
        } else if (wallName === 'R_L_L_S_W') {
            return {
                min: params.leanR_p_pos - params.leanR_p_d / 2 + params.rightLeanStoragePosition,
                max: params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right) + params.rightLeanStoragePosition
            } 
        } else if (wallName === 'L_L_L_S_W') {
            return {
                min: params.lean_p_pos - params.lean_p_d / 2 + params.leftLeanStoragePosition,
                max: params.lean_p_pos - params.lean_p_d / 2 + parseInt(params.add_storage) + params.leftLeanStoragePosition
            } 
        } else if (wallName === 'L_L_R_S_W') {
            return {
                min: -params.lean_p_pos + params.lean_p_d / 2 - parseInt(params.add_storage) - params.leftLeanStoragePosition,
                max: -params.lean_p_pos + params.lean_p_d / 2 - params.leftLeanStoragePosition
            } 
        } else if (wallName === 'G_L_L_F_W' || wallName === 'G_L_L_F_S_W') {
            return {
                min: -params.lean_p_w / 2 + params.lean_p_pos,
                max: params.lean_p_w / 2 + params.lean_p_pos
            }
        } else if (wallName === 'G_L_L_B_W' || wallName === 'G_L_L_B_S_W') {
            return {
                min: -params.lean_p_w / 2 - params.lean_p_pos,
                max: params.lean_p_w / 2 - params.lean_p_pos
            }
        } else if (wallName === 'G_L_L_L_W') {
            return {
                min: params.p_w / 2,
                max: params.p_w / 2 + params.lean_p_d
            }
        } else if (wallName === 'G_L_L_R_W') {
            return {
                min: -params.p_w / 2 - params.lean_p_d,
                max: -params.p_w / 2
            }
        } else if (wallName === 'G_L_L_L_S_W') {
            return {
                min: params.p_w / 2 + params.leftLeanStoragePosition,
                max: params.p_w / 2 + params.leftLeanStoragePosition + parseInt(params.add_storage)
            }
        } else if (wallName === 'G_L_L_R_S_W') {
            return {
                min: -params.p_w / 2 - params.leftLeanStoragePosition - parseInt(params.add_storage),
                max: -params.p_w / 2 - params.leftLeanStoragePosition
            }
        } else if (wallName === 'G_R_L_F_W' || wallName === 'G_R_L_F_S_W') {
            return {
                min: -params.leanR_p_w / 2 - params.leanR_p_pos,
                max: params.leanR_p_w / 2 - params.leanR_p_pos
            }
        } else if (wallName === 'G_R_L_B_W' || wallName === 'G_R_L_B_S_W') {
            return {
                min: -params.leanR_p_w / 2 + params.leanR_p_pos,
                max: params.leanR_p_w / 2 + params.leanR_p_pos
            }
        } else if (wallName === 'G_R_L_L_W') {
            return {
                min: params.p_w / 2,
                max: params.p_w / 2 + params.leanR_p_d
            }
        } else if (wallName === 'G_R_L_R_W') {
            return {
                min: -params.p_w / 2 - params.leanR_p_d,
                max: -params.p_w / 2
            }
        } else if (wallName === 'G_R_L_L_S_W') {
            return {
                min: params.p_w / 2 + params.rightLeanStoragePosition,
                max: params.p_w / 2 + params.rightLeanStoragePosition + parseInt(params.add_storage_right)
            }
        } else if (wallName === 'G_R_L_R_S_W') {
            return {
                min: -params.p_w / 2 - params.rightLeanStoragePosition - parseInt(params.add_storage_right),
                max: -params.p_w / 2 - params.rightLeanStoragePosition
            }
        } else if (wallName === 'G_F_L_F_W' || wallName === 'G_F_L_F_S_W') {
            return {
                min: -params.leanF_p_w / 2 + params.leanF_p_pos,
                max: params.leanF_p_w / 2 + params.leanF_p_pos
            }
        } else if (wallName === 'G_F_L_B_W' || wallName === 'G_F_L_B_S_W') {
            return {
                min: -params.leanF_p_w / 2 - params.leanF_p_pos,
                max: params.leanF_p_w / 2 - params.leanF_p_pos
            }
        } else if (wallName === 'G_F_L_L_W') {
            return {
                min: params.p_d / 2,
                max: params.p_d / 2 + params.leanF_p_d
            }
        } else if (wallName === 'G_F_L_R_W') {
            return {
                min: -params.p_d / 2 - params.leanF_p_d,
                max: -params.p_d / 2
            }
        } else if (wallName === 'G_F_L_L_S_W') {
            return {
                min: params.p_d / 2 + params.frontLeanStoragePosition,
                max: params.p_d / 2 + params.frontLeanStoragePosition + parseInt(params.add_storage_front)
            }
        } else if (wallName === 'G_F_L_R_S_W') {
            return {
                min: -params.p_d / 2 - params.frontLeanStoragePosition - parseInt(params.add_storage_front),
                max: -params.p_d / 2 - params.frontLeanStoragePosition
            }
        } else if (wallName === 'G_B_L_F_W' || wallName === 'G_B_L_F_S_W') {
            return {
                min: -params.leanB_p_w / 2 - params.leanB_p_pos,
                max: params.leanB_p_w / 2 - params.leanB_p_pos
            }
        } else if (wallName === 'G_B_L_B_W' || wallName === 'G_B_L_B_S_W') {
            return {
                min: -params.leanB_p_w / 2 + params.leanB_p_pos,
                max: params.leanB_p_w / 2 + params.leanB_p_pos
            }
        } else if (wallName === 'G_B_L_L_W') {
            return {
                min: params.p_d / 2,
                max: params.p_d / 2 + params.leanB_p_d
            }
        } else if (wallName === 'G_B_L_R_W') {
            return {
                min: -params.p_d / 2 - params.leanB_p_d,
                max: -params.p_d / 2
            }
        } else if (wallName === 'G_B_L_L_S_W') {
            return {
                min: params.p_d / 2 + params.backLeanStoragePosition,
                max: params.p_d / 2 + params.backLeanStoragePosition + parseInt(params.add_storage_back)
            }
        } else if (wallName === 'G_B_L_R_S_W') {
            return {
                min: -params.p_d / 2 - params.backLeanStoragePosition - parseInt(params.add_storage_back),
                max: -params.p_d / 2 - params.backLeanStoragePosition
            }
        }
    }, [wallName, params.p_w, params.p_d, params.leanF_p_w, params.leanF_p_d, params.leanF_p_pos, params.frontLeanStoragePosition, params.backLeanStoragePosition, params.leftLeanStoragePosition, params.rightLeanStoragePosition, params.leanB_p_w, params.leanB_p_d, params.leanB_p_pos, params.leanR_p_w, params.leanR_p_d, params.leanR_p_pos, params.lean_p_w, params.lean_p_d, params.lean_p_pos, params.add_left_front_lean_porch, params.add_right_front_lean_porch, params.add_right_back_lean_porch, params.add_left_back_lean_porch, params.p_u_t, params.cB_addStorage_left, params.cB_addStorage_right, params.add_storage_front, params.add_storage_back, params.add_storage_right, params.add_storage, params.endStoragePositionZ])

    const limitY = useMemo(() => {
        let regularHeight = 0;

        if (params.p_r_s === 1) {
            regularHeight = const_var.roofRegularDst * 2
        } else {
            regularHeight = 0;
        }
        
        if (params.singleSlope) {
            if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w') {
                return params.p_h - (params.p_r_p / 12) * ((params.p_w / 2) - positionX);
            } else if(wallName === 'c_b_b_w'){
                return params.p_h - (params.p_r_p / 12) * ((params.p_w / 2) + positionX);
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_l_s_w') {
                return params.p_h - (params.p_r_p / 12) * params.p_w;
            } else if (wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w') {
                return params.p_h;
            } else if (wallName === 'c_b_l_s_r_w') {
                return params.p_h - (params.p_w - (parseInt(params.cB_addStorage_left)) + 0.0075) * params.p_r_p / 12;
            } else if (wallName === 'c_b_l_s_f_w') {
                return params.p_h - (params.p_w - (parseInt(params.cB_addStorage_left)) + 0.0075 - positionX) * params.p_r_p / 12;
            } else if (wallName === 'c_b_l_s_b_w') {
                return params.p_h - (params.p_w - (parseInt(params.cB_addStorage_left)) + 0.0075 + positionX) * params.p_r_p / 12;
            } else if (wallName === 'c_b_r_s_l_w') {
                return params.p_h - (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12;
            } else if (wallName === 'c_b_r_s_f_w') {
                return params.p_h - (params.p_w - (parseInt(params.cB_addStorage_right)) + 0.0075 - positionX) * params.p_r_p / 12;
            } else if (wallName === 'c_b_r_s_b_w') {
                return params.p_h - (params.p_w - (parseInt(params.cB_addStorage_right)) + 0.0075 + positionX) * params.p_r_p / 12;
            } else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
                return params.leanR_p_h + (params.b_l_t_r_pR / 12) * (params.p_w / 2 + params.leanR_p_w - positionX) + regularHeight;
            } else if (wallName === 'R_L_B_W') {
                return params.leanR_p_h + (params.b_l_t_r_pR / 12) * (params.p_w / 2 + params.leanR_p_w + positionX) + regularHeight;
            } else if (wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W') {
                return params.leanR_p_h;
            }
        } else {
            if (wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w') {
                return params.p_h + (params.p_r_p / 12) * ((params.p_w / 2) - Math.abs(positionX)) + regularHeight;
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w' || wallName === 'c_b_l_s_w') {
                return params.p_h;
            } else if (wallName === 'F_L_R_W' || wallName === 'F_L_R_S_W') {
                return params.leanF_p_h + (params.b_l_t_r_pF / 12) * (params.p_d / 2 + params.leanF_p_w + positionX) + regularHeight;
            } else if (wallName === 'F_L_L_W') {
                return params.leanF_p_h + (params.b_l_t_r_pF / 12) * (params.p_d / 2 + params.leanF_p_w - positionX) + regularHeight;
            } else if (wallName === 'F_L_F_W' || wallName === 'F_L_F_S_W') {
                return params.leanF_p_h;
            } else if (wallName === 'B_L_F_W' || wallName === 'B_L_L_S_W') {
                return params.leanB_p_h + (params.b_l_t_r_pB / 12) * (params.p_d / 2 + params.leanB_p_w - positionX ) + regularHeight;
            } else if (wallName === 'B_L_B_W') {
                return params.leanB_p_h + (params.b_l_t_r_pB / 12) * (params.p_d / 2 + params.leanB_p_w + positionX ) + regularHeight;
            } else if (wallName === 'B_L_S_W' || wallName === 'B_L_F_S_W') {
                return params.leanB_p_h;
            } else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
                return params.leanR_p_h + (params.b_l_t_r_pR / 12) * (params.p_w / 2 + params.leanR_p_w - positionX) + regularHeight;
            } else if (wallName === 'R_L_B_W') {
                return params.leanR_p_h + (params.b_l_t_r_pR / 12) * (params.p_w / 2 + params.leanR_p_w + positionX) + regularHeight;
            } else if (wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W') {
                return params.leanR_p_h;
            } else if (wallName === 'L_L_F_W' || wallName === 'L_L_F_S_W') {
                return  params.lean_p_h + (params.b_l_t_r_p / 12) * (params.p_w / 2 + params.lean_p_w + positionX) + regularHeight;
            } else if (wallName === 'L_L_B_W') {
                return params.lean_p_h + (params.b_l_t_r_p / 12) * (params.p_w / 2 + params.lean_p_w - positionX) + regularHeight;
            } else if (wallName === 'L_L_L_W' || wallName === 'L_L_L_S_W') {
                return params.lean_p_h;
            } else if (wallName === 'G_L_L_F_W' || wallName === 'G_L_L_F_S_W') {
                return params.lean_p_h + (params.b_l_t_r_p / 12) * (params.lean_p_w / 2 - Math.abs(positionX - params.lean_p_pos)) + regularHeight;
            } else if (wallName === 'G_L_L_B_W' || wallName === 'G_L_L_B_S_W') {
                return params.lean_p_h + (params.b_l_t_r_p / 12) * (params.lean_p_w / 2 - Math.abs(positionX + params.lean_p_pos)) + regularHeight;
            } else if (wallName === 'G_L_L_L_W' || wallName === 'G_L_L_L_S_W' || wallName === 'G_L_L_R_W' || wallName === 'G_L_L_R_S_W') {
                return params.lean_p_h + regularHeight;
            } else if (wallName === 'G_R_L_F_W' || wallName === 'G_R_L_F_S_W') {
                return params.leanR_p_h + (params.b_l_t_r_pR / 12) * (params.leanR_p_w / 2 - Math.abs(positionX + params.leanR_p_pos)) + regularHeight;
            } else if (wallName === 'G_R_L_B_W' || wallName === 'G_R_L_B_S_W') {
                return params.leanR_p_h + (params.b_l_t_r_pR / 12) * (params.leanR_p_w / 2 - Math.abs(positionX - params.leanR_p_pos)) + regularHeight;
            } else if (wallName === 'G_R_L_L_W' || wallName === 'G_R_L_L_S_W' || wallName === 'G_R_L_R_W' || wallName === 'G_R_L_R_S_W') {
                return params.leanR_p_h + regularHeight;
            } else if (wallName === 'G_F_L_F_W' || wallName === 'G_F_L_F_S_W') {
                return params.leanF_p_h + (params.b_l_t_r_pF / 12) * (params.leanF_p_w / 2 - Math.abs(positionX - params.leanF_p_pos)) + regularHeight;
            } else if (wallName === 'G_F_L_B_W' || wallName === 'G_F_L_B_S_W') {
                return params.leanF_p_h + (params.b_l_t_r_pF / 12) * (params.leanF_p_w / 2 - Math.abs(positionX + params.leanF_p_pos)) + regularHeight;
            } else if (wallName === 'G_F_L_L_W' || wallName === 'G_F_L_L_S_W' || wallName === 'G_F_L_R_W' || wallName === 'G_F_L_R_S_W') {
                return params.leanF_p_h + regularHeight;
            } else if (wallName === 'G_B_L_F_W' || wallName === 'G_B_L_F_S_W') {
                return params.leanB_p_h + (params.b_l_t_r_pB / 12) * (params.leanB_p_w / 2 - Math.abs(positionX + params.leanB_p_pos)) + regularHeight;
            } else if (wallName === 'G_B_L_B_W' || wallName === 'G_B_L_B_S_W') {
                return params.leanB_p_h + (params.b_l_t_r_pB / 12) * (params.leanB_p_w / 2 - Math.abs(positionX - params.leanB_p_pos)) + regularHeight;
            } else if (wallName === 'G_B_L_L_W' || wallName === 'G_B_L_L_S_W' || wallName === 'G_B_L_R_W' || wallName === 'G_B_L_R_S_W') {
                return params.leanB_p_h + regularHeight;
            } else if (wallName === 'c_b_l_s_r_w') {
                let overHeight = 0;
                if (parseInt(params.cB_addStorage_left) < params.p_w / 2) {
                    overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + regularHeight;
                } else {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + regularHeight;
                }

                return params.p_h + overHeight;
            } else if (wallName === 'c_b_l_s_f_w' || wallName === 'c_b_l_s_b_w') {
                return params.p_h + (params.p_r_p / 12) * ((params.p_w / 2) - Math.abs(positionX)) + regularHeight;
            } else if (wallName === 'c_b_r_s_l_w') {
                let overHeight = 0;
                if (parseInt(params.cB_addStorage_right) < params.p_w / 2) {
                    overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + regularHeight;
                } else {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + regularHeight;
                }

                return params.p_h + overHeight;
            } else if (wallName === 'c_b_r_s_f_w' || wallName === 'c_b_r_s_b_w') {
                return params.p_h + (params.p_r_p / 12) * ((params.p_w / 2) - Math.abs(positionX)) + regularHeight;
            } else if (wallName === 'R_L_L_S_W') {
                return params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w;
            } else if (wallName === 'L_L_R_S_W') {
                return params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w;
            }
        }
    
    }, [wallName, positionX, params.singleSlope, params.p_w, params.p_h, params.p_r_s, params.p_r_p, params.leanF_p_h, params.leanF_p_w, params.b_l_t_r_pF, params.leanB_p_h, params.leanB_p_w, params.b_l_t_r_pB, params.leanR_p_h, params.leanR_p_w, params.b_l_t_r_pR, params.lean_p_h, params.lean_p_w, params.b_l_t_r_p, params.cB_addStorage_left, params.cB_addStorage_right]);
    
    useMemo(() => {
        const targetWallNameArr = wallNameArrForValid.find(subArray => subArray.includes(wallName));
        const sideArray = [...const_var.newDoorsArray.filter((item) => item.uniqueId !== id && targetWallNameArr.includes(item.userData.wallName) && item.positionY - item.height / 2 <= positionY + height / 2)];
        const TopArray = [...const_var.newDoorsArray.filter((item) => item.uniqueId !== id && targetWallNameArr.includes(item.userData.wallName) && item.positionX - item.width / 2 <= positionX + width / 2 && item.positionX + item.width / 2 >= positionX - width / 2 && item.positionY - item.height / 2 >= positionY + height / 2)];
        
        let valLeft = limitX.min;
        let valRight = limitX.max;
        let valTop = limitY;
        let lineLengthOffset = 0;
        let linePositionOffset = 0;

        if (TopArray.length > 0) {
            let sortedTopArray;
            let targetTopIndex;
            if (bindDelta[0] >= 0) {
                sortedTopArray = [...TopArray.map(item => ({id: item.uniqueId, posY: item.positionY, height: item.height})), {id, posY: positionY, height}].sort((a, b) => (a.posY - a.height / 2) - (b.posY - b.height / 2));
            } else {
                sortedTopArray = [...TopArray.map(item => ({id: item.uniqueId, posY: item.positionY, height: item.height})), {id, posY: positionY, height}].sort((a, b) => (a.posY + a.height / 2) - (b.posY + b.height / 2));
            }
            targetTopIndex = sortedTopArray.findIndex(el => el.id === id);

            const frTopObj = TopArray.find(item => item.uniqueId === sortedTopArray[targetTopIndex + 1].id);
            valTop = frTopObj.positionY - frTopObj.height / 2;
        }

        if (sideArray.length > 0) {
            let sortedSideArray;
            let targetIndex;

            if (bindDelta[0] >= 0) {
                sortedSideArray = [...sideArray.map(item => ({id: item.uniqueId, posX: item.positionX, width: item.width})), {id, posX: positionX, width}].sort((a, b) => (a.posX - a.width / 2) - (b.posX - b.width / 2));
            } else {
                sortedSideArray = [...sideArray.map(item => ({id: item.uniqueId, posX: item.positionX, width: item.width})), {id, posX: positionX, width}].sort((a, b) => (a.posX + a.width / 2) - (b.posX + b.width / 2));
            }
            targetIndex = sortedSideArray.findIndex(el => el.id === id);

            if (targetIndex === 0) {
                const frRightObj = sideArray.find(item => item.uniqueId === sortedSideArray[targetIndex + 1].id);
                valRight = frRightObj.positionX - frRightObj.width / 2;
                if (positionX + width / 2 > frRightObj.positionX - frRightObj.width / 2) {
                    if (sortedSideArray[targetIndex + 2]) {
                        const sdRightObj = sideArray.find(item => item.uniqueId === sortedSideArray[targetIndex + 2].id);
                        valRight = sdRightObj.positionX - sdRightObj.width / 2;
                    } else {
                        valRight = limitX.max;
                    }
                }
            } else if (targetIndex === sortedSideArray.length - 1) {
                const frLeftObj = sideArray.find(item => item.uniqueId === sortedSideArray[targetIndex - 1].id);
                valLeft = frLeftObj.positionX + frLeftObj.width / 2;
                if (positionX - width / 2 < frLeftObj.positionX + frLeftObj.width / 2) {
                    if (sortedSideArray[targetIndex - 2]) {
                        const sdLeftObj = sideArray.find(item => item.uniqueId === sortedSideArray[targetIndex - 2].id);
                        valLeft = sdLeftObj.positionX + sdLeftObj.width / 2;
                    } else {
                        valLeft = limitX.min;
                    }
                }
            } else {
                const frLeftObj = sideArray.find(item => item.uniqueId === sortedSideArray[targetIndex - 1].id);
                const frRightObj = sideArray.find(item => item.uniqueId === sortedSideArray[targetIndex + 1].id);
                valLeft = frLeftObj.positionX + frLeftObj.width / 2;
                valRight = frRightObj.positionX - frRightObj.width / 2;

                if (positionX + width / 2 > frRightObj.positionX - frRightObj.width / 2) {
                    if (sortedSideArray[targetIndex + 2]) {
                        const sdRightObj = sideArray.find(item => item.uniqueId === sortedSideArray[targetIndex + 2].id);
                        valRight = sdRightObj.positionX - sdRightObj.width / 2;
                    } else {
                        valRight = limitX.max;
                    }
                }
                if (positionX - width / 2 < frLeftObj.positionX + frLeftObj.width / 2) {
                    if (sortedSideArray[targetIndex - 2]) {
                        const sdLeftObj = sideArray.find(item => item.uniqueId === sortedSideArray[targetIndex - 2].id);
                        valLeft = sdLeftObj.positionX + sdLeftObj.width / 2;
                    } else {
                        valLeft = limitX.min;
                    }
                }
            }
            if (valLeft <= limitX.min) valLeft = limitX.min;
            if (valRight >= limitX.max) valRight = limitX.max;
        }

        if (wallName === 'G_L_L_L_S_W') {
            lineLengthOffset = 0.2;
            if (params.leftLeanStoragePosition === 0) {
                linePositionOffset = 0.1;
            } else if (params.leftLeanStoragePosition === params.lean_p_d - parseInt(params.add_storage)) {
                linePositionOffset = -0.1;
            }
        } else if (wallName === 'G_L_L_R_S_W') {
            lineLengthOffset = 0.2;
            if (params.leftLeanStoragePosition === 0) {
                linePositionOffset = -0.1;
            } else if (params.leftLeanStoragePosition === params.lean_p_d - parseInt(params.add_storage)) {
                linePositionOffset = 0.1;
            }
        } else if (wallName === 'G_R_L_L_S_W') {
            lineLengthOffset = 0.2;
            if (params.rightLeanStoragePosition === 0) {
                linePositionOffset = 0.1;
            } else if (params.rightLeanStoragePosition === params.leanR_p_d - parseInt(params.add_storage_right)) {
                linePositionOffset = -0.1;
            }
        } else if (wallName === 'G_R_L_R_S_W') {
            lineLengthOffset = 0.2;
            if (params.rightLeanStoragePosition === 0) {
                linePositionOffset = -0.1;
            } else if (params.rightLeanStoragePosition === params.leanR_p_d - parseInt(params.add_storage_right)) {
                linePositionOffset = 0.1;
            }
        } else if (wallName === 'G_F_L_L_S_W') {
            lineLengthOffset = 0.2;
            if (params.frontLeanStoragePosition === 0) {
                linePositionOffset = 0.3;
            } else if (params.frontLeanStoragePosition === params.leanF_p_d - parseInt(params.add_storage_front)) {
                linePositionOffset = -0.1;
            }
        } else if (wallName === 'G_F_L_R_S_W') {
            lineLengthOffset = 0.2;
            if (params.frontLeanStoragePosition === 0) {
                linePositionOffset = -0.3;
            } else if (params.frontLeanStoragePosition === params.leanF_p_d - parseInt(params.add_storage_front)) {
                linePositionOffset = 0.1;
            }
        } else if (wallName === 'G_B_L_L_S_W') {
            lineLengthOffset = 0.2;
            if (params.backLeanStoragePosition === 0) {
                linePositionOffset = 0.3;
            } else if (params.backLeanStoragePosition === params.leanB_p_d - parseInt(params.add_storage_back)) {
                linePositionOffset = -0.1;
            }
        } else if (wallName === 'G_B_L_R_S_W') {
            lineLengthOffset = 0.2;
            if (params.backLeanStoragePosition === 0) {
                linePositionOffset = -0.3;
            } else if (params.backLeanStoragePosition === params.leanB_p_d - parseInt(params.add_storage_back)) {
                linePositionOffset = 0.1;
            }
        }
        setArrowLength(Math.abs(limitX.max - limitX.min) + lineLengthOffset);
        setArrowPosition(-(positionX - (limitX.min + Math.abs(limitX.max - limitX.min) / 2) - linePositionOffset));
        setTopHeight(valTop - positionY - height / 2 + 0.15);
        setWidthLeft(Math.abs(positionX - width / 2 - valLeft));
        setWidthRight(Math.abs(valRight - positionX - width / 2));
        setVerticalArrowLength(limitY);

        if (compType === "garage_door" || compType === "garage_door_frameout") {
            setTargetDoorSize(`${width}'x${height}'`);
        } else {
            setTargetDoorSize(`${width * 12}"x${height * 12}"`);
        }
        setHeightestSize(height);
        
    }, [id, width, height, limitX, limitY, positionX, positionY, wallName, params.p_r_p, params.singleSlope, bindDelta, const_var.newDoorsArray])
    
    // useEffect(() => {
    //     if (const_var.callMesure) {
    //         let sideArray = const_var.newDoorsArray.filter((item) => item.userData.wallName === wallName);
    //         let sortArray = sortDoorObject(sideArray);

    //         const targetDoorObject = sortArray.find(item => item.uniqueId === id);
    //         setHeightestSize(targetDoorObject.height) /// get the value of the heightest size in sideArray
    //         if(targetDoorObject.userData.compType === "walkin"){
    //             setTargetDoorSize(convertSizeFormat(targetDoorObject.size, 'walkin'))
    //         } else {
    //             setTargetDoorSize(convertSizeFormat(targetDoorObject.size, 'door'))
    //         }
    //     }
    // }, [const_var.callMesure, const_var.newDoorsArray, isDrag, wallName, id]);

    useMemo(() => {
        if(limitX.min - (positionX - width / 2) > -3.3){
            if((params.p_l_w !== 'Open' && wallName === 'c_b_f_s_w') || 
                (params.p_f_w !== 'Open' && wallName === 'c_b_l_s_r_w') || 
                (params.p_b_w !== 'Open' && wallName === 'c_b_r_s_l_w') ||
                (params.p_b_c_b_l !== 'Open' && wallName === 'L_L_F_S_W') ||
                (params.p_r_w !== 'Open' && wallName === 'R_L_F_S_W') ||
                (params.p_b_w !== 'Open' && wallName === 'R_L_L_S_W') ||
                (params.p_b_c_b_f_l !== 'Open' && wallName === 'F_L_R_S_W') ||
                (params.p_b_w !== 'Open' && wallName === 'B_L_L_S_W')){
                    setLeftAngle(Math.PI / 2)
                } else {
                setLeftAngle(0)
            }
        } else {
            setLeftAngle(0)
        }
        if(limitX.max - (positionX + width / 2) < 3.3){
            if((params.p_r_w !== 'Open' && wallName === 'c_b_f_s_w') || 
            (params.p_b_w !== 'Open' && wallName === 'c_b_l_s_r_w') || 
            (params.p_f_w !== 'Open' && wallName === 'c_b_r_s_l_w') ||
            (params.p_l_w !== 'Open' && wallName === 'L_L_F_S_W') ||
            (params.p_b_w !== 'Open' && wallName === 'L_L_R_S_W') ||
            (params.p_b_c_b_r !== 'Open' && wallName === 'R_L_F_S_W') ||
            (params.p_f_w !== 'Open' && wallName === 'F_L_R_S_W') || 
            (params.p_b_c_b_b_l !== 'Open' && wallName === 'B_L_L_S_W')) {
                setRightAngle(-Math.PI / 2)
            } else {
                setRightAngle(0)
            }
        } else {
            setRightAngle(0)
        }
    }, [limitX.min, limitX.max, params.p_l_w, wallName, params.p_f_w, params.p_b_w, params.p_r_w, params.p_l_w, params.p_b_c_b_r, params.p_b_c_b_b_l, params.p_b_c_b_f_l, params.p_b_c_b_l, width, positionX]);

    return const_var.callMesure && (
        <>
            <DimensionValue type={'door'} dir={'cmpSize'} position={[0, (heightestSize - height / 2), isDrag ? 0.5 : 0.15]} rotation={[0, 0, 0]} value={targetDoorSize} slopeAngle={0} cmpPos={[positionX, positionY, positionZ]} />
            {isDrag &&
                <group>
                    <group position={[arrowPosition, (heightestSize - height / 2) - 0.2, 0.3]}>
                        <LineModel name="horizontal" length={arrowLength} position={[0, 0.1, 0]} rotation={[0, 0, Math.PI / 2]} color={color} />
                    </group>
                    <group position={[0, -positionY, 0.3]}>
                        <LineModel name="vertical" length={verticalArrowLength - height} position={[0, verticalArrowLength / 2 + height / 2, 0]} color={color} />
                    </group>
                    
                    {sideDoorArray.map((item) => (
                        <group key={item.uniqueId} >
                            <DoorSideLine length={heightestSize} position={[-width / 2 + 0.1, (heightestSize - height) / 2, isDrag ? 0.7 : 0.5]} />
                            <DoorSideLine length={heightestSize} position={[width / 2 - 0.1, (heightestSize - height) / 2, isDrag ? 0.7 : 0.5]} />
                        </group>
                    ))}
                    
                    <DimensionValue type={'door'} dir={'left'} position={[-width / 2, (heightestSize - height / 2), 0.5]} rotation={[0, 0, leftAngle]} value={convertFeet(widthLeft) + ' W'} slopeAngle={0} cmpPos={[positionX, positionY, positionZ]} />
                    <DimensionValue type={'door'} dir={'right'} position={[width / 2, (heightestSize - height / 2), 0.5]} rotation={[0, 0, rightAngle]} value={convertFeet(widthRight) + ' W'} slopeAngle={0} cmpPos={[positionX, positionY, positionZ]} />
                    <DimensionValue type={'door'} dir={'top'} position={[0, height / 2, isDrag ? 0.5 : 0.15]} value={convertFeet(topHeight) + ' H'} slopeAngle={0} cmpPos={[positionX, positionY, positionZ]} />
                </group>
            }
        </>  
    )
}

export default Door_Measurements;